import { useState } from "react";

const Faqs = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "EvoTeam nima?",
      answer:
        "EvoTeam – bu yuqori sifatli dasturlash va veb-texnologiyalar sohasidagi xizmatlar bilan ta'minlovchi kompaniya. Biz veb-saytlar, mobil ilovalar, e-tijorat platformalarini yaratishda yordam beramiz va texnologik yechimlarni taqdim etamiz. Bizning maqsadimiz mijozlarimizga zamonaviy va samarali veb-yechimlar taklif qilishdir.",
    },
    {
      question: "Siz qanday turdagi xizmatlarni taklif qilasiz?",
      answer:
        "Biz quyidagi xizmatlarni taqdim etamiz: Oddiy landing page yaratish, Mobil va SEO optimizatsiya, Responsive (mobilga mos), Admin panel bilan ishlaydigan sayt, Telegram bot yaratish, Sayt tezligini oshirish va optimizatsiya, Katta va murakkab web platformalar yaratish.",
    },
    {
      question: "Xizmatlaringizdan qanday foydalanish mumkin?",
      answer:
        "Xizmatlarimizdan foydalanish uchun yuqoridagi 'Xizmatlar va Narxlar' bo‘limidan o‘zingizga mos xizmatni tanlang va 'Foydalanish' tugmasini bosing. Shundan so‘ng, siz maxsus Telegram botga yo‘naltirilasiz, u yerda biz bilan bog‘lanishingiz mumkin. Shuningdek, saytning yuqori qismidagi 'Aloqa' bo‘limiga o‘tib, kerakli ma’lumotlarni to‘ldirish orqali ham biz bilan bog‘lanishingiz mumkin. So‘rovingizni qabul qilgach, siz bilan tez orada aloqaga chiqamiz.",
    },
    {
      question: "Xizmat narxlari qanday?",
      answer:
        "Xizmatlarimiz narxlari haqida to‘liq ma’lumot olish uchun yuqoridagi 'Xizmatlar va Narxlar' qismidan bilib olishingiz va 'Foydalanish' tugmasini bosib biz bilan bog‘lanishingiz mumkin.",
    },
    {
      question: "To‘lov usullari qanday?",
      answer:
        "Biz quyidagi to‘lov usullarini qabul qilamiz: [Payme, Click, naqd to‘lov, bank o‘tkazmasi va boshqalar].",
    },
    {
      question: "Sizning xizmatlaringiz qancha vaqt davom etadi?",
      answer:
        "Xizmat turiga qarab vaqt har xil bo‘lishi mumkin. O‘rtacha [1oy] davom etadi.",
    },
    {
      question: "Xizmatlar faqat bitta hududda mavjudmi yoki butun O‘zbekiston bo‘ylab",
      answer:
        "Biz asosan Online ishlaganimiz sabab agar siz O'zbekiston xududidan tashqarida bolsangizham biz siz bilan ishlashga tayyormiz.",
    },
    {
      question: "Mijozlarga qo‘llab-quvvatlash xizmati mavjudmi?",
      answer:
        "Ha, biz mijozlarga 24/7 qo‘llab-quvvatlash xizmatini taqdim etamiz. Shuning uchun biz bilan o'zingizga qulay joyda va o'zingizga qulay vaqtda murojat qilshingiz mumkin.",
    },
  ];

  return (
    <section className="py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col justify-center items-center gap-x-16 gap-y-5 xl:gap-28 lg:flex-row lg:justify-between max-lg:max-w-2xl mx-auto max-w-full">
          <div className="w-full lg:w-1/2">
            <img
              src="https://pagedone.io/asset/uploads/1696230182.png"
              alt="FAQ tailwind section"
              className="w-full rounded-xl object-cover"
            />
          </div>
          <div className="w-full lg:w-1/2">
            <div className="lg:max-w-xl">
              <div className="mb-6 lg:mb-16">
                <h6 className="text-lg text-center font-medium text-indigo-600 mb-2 lg:text-left">
                Tez-tez so'raladigan savollar
                </h6>
                <h2 className="text-4xl text-center font-bold text-gray-900 leading-[3.25rem] mb-5 lg:text-left">
                Javoblarni qidiryapsizmi?
                </h2>
              </div>
              <div className="accordion-group">
                {faqs.map((faq, index) => (
                  <div
                    key={index}
                    className={`accordion py-8 border-b border-solid border-gray-200 ${
                      activeIndex === index ? "active" : ""
                    }`}
                  >
                    <button
                      className="accordion-toggle group inline-flex items-center justify-between text-xl font-normal leading-8 text-gray-600 w-full transition duration-500 hover:text-indigo-600"
                      onClick={() => toggleAccordion(index)}
                    >
                      <h5>{faq.question}</h5>
                      <svg
                        className={`text-gray-900 transition duration-500 ${
                          activeIndex === index ? "rotate-180" : ""
                        }`}
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16.5 8.25L12.4142 12.3358C11.7475 13.0025 11.4142 13.3358 11 13.3358C10.5858 13.3358 10.2525 13.0025 9.58579 12.3358L5.5 8.25"
                          stroke="currentColor"
                          strokeWidth="1.6"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                      </svg>
                    </button>
                    <div
                      className={`accordion-content w-full px-0 overflow-hidden pr-4 ${
                        activeIndex === index ? "block" : "hidden"
                      }`}
                    >
                      <p className="text-base text-gray-500 font-normal">
                        {faq.answer}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Faqs;

